<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> Retainer
        </button>
      </template>
    </app-header>

    <div class="container my-5">
      <h2>Retainers.</h2>

      <list-filters v-model="params" />

      <c-data-list ref="dataList" :items="retainers" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-4 col-xl-4">
            <p>Client</p>
          </div>
          <div class="col-6 col-lg-3 col-xl-3">
            <p>Amount</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Start</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">
            <p>End</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <retainers-list-item :retainer="slotProps.item" />
        </template>
      </c-data-list>
    </div>

    <retainers-modal
      ref="modal"
      @created="newRetainerCreated"
      title="Create Retainer"
      :retainer="newRetainer"
      mode="create"
    ></retainers-modal>
  </div>
</template>

<script>
import { isEqual } from "lodash";
import { mapState, mapActions } from "vuex";
import RetainersModal from "./RetainersModal";
import RetainersListItem from "./RetainersListItem";
import ListFilters from "./ListFilters";

import RetainerModel from "./../../models/retainer.js";

export default {
  components: {
    RetainersModal,
    RetainersListItem,
    ListFilters
  },

  data: function () {
    return {
      loading: true,
      params: {},
      newRetainer: new RetainerModel(),
    };
  },
  mounted: function () {
    this.getRetainers(this.params);

    this.$watch("params", async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return;
      }

      await this.getRetainers(this.params);
    });
  },

  computed: {
    ...mapState("retainer", { retainers: "list", pagination: "pagination" }),
  },

  methods: {
    ...mapActions("retainer", {
      getRetainers: "getList",
      getRetainersForNextPage: "getListForNextPage",
    }),

    async loadNextPage(done) {
      try {
        await this.getRetainersForNextPage(this.params);

        done();
      } catch (error) {
        done(true);
      }
    },

    newRetainerCreated() {
      this.getRetainers(this.params)
    },
  },
};
</script>

<style scoped>
</style>
